import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { AddIconButton } from 'features/menu/pages/recent-items-page/recent-order-card-list/recent-order-card-list-item/styled';

import { ILegacyCartEntry } from '@rbi-ctg/menu';
import useAddToCartRecentItem from 'hooks/use-add-to-cart-recent-item';
import { CustomEventNames } from 'state/amplitude';
import { t } from 'state/intl/translations';

interface AddToCartProps {
  disabled: boolean;
  cartEntry: ILegacyCartEntry;
  amplitudeEvent?: CustomEventNames;
}

const AddToCart: React.FC<React.PropsWithChildren<AddToCartProps>> = ({
  disabled,
  cartEntry,
  amplitudeEvent,
}) => {
  const { addToCart, SwitchCartMethodDialog } = useAddToCartRecentItem({
    cartEntry,
    amplitudeEvent,
  });

  return (
    <>
      <AddIconButton
        variant="outline"
        onPress={addToCart}
        icon={<Icon variant={'add'} />}
        disabled={disabled}
        testID="add-to-cart"
        accessibilityLabel={t('addToCart')}
      />
      <SwitchCartMethodDialog />
    </>
  );
};

export default AddToCart;
